<mat-form-field appearance="fill" class="w-full ">
  <mat-label>{{label}}</mat-label>
  <input matInput [formControl]="emailFormControl" placeholder="{{placeholder}}" class="focus:ring-0">
  @if (emailFormControl.hasError('email') && !emailFormControl.hasError('required') && emailFormControl.touched) {
  <mat-error>{{"PARKIFLY.ERROR.VALID_EMAIL" | transloco}}</mat-error>
  }
  @if (emailFormControl.hasError('required') && emailFormControl.touched) {
  <mat-error>{{label}} {{"PARKIFLY.ERROR.IS_REQUIRED" | transloco}}</mat-error>
  }
</mat-form-field>